import React from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "../../layout/userlayout/layout.component";
import jwtDecode from "jwt-decode";

const RegRoute = ({ component: Component, ...rest }) => {
  let valid = rest.state.isValid;
  let mobile_number = rest.phone;
  const userData = rest.state.payload ? jwtDecode(rest.state.payload) : null;
  
  const userType = userData?.user?.user_type;
  console.log(userType)
  //console.log(rest);
  return (
    <Route
      {...rest}
      render={(props) =>
        valid || userType === 21 ? (
          <Layout
            {...props}
            {...rest}
            key={rest.location?.key}
            mobile_number={rest.phone}
          >
            <Component
              {...props}
              {...rest}
              mobile_number={rest.phone}
              key={rest.location?.key}
            />
          </Layout>
        ) : (
          <Redirect to="/registration" />
        )
      }
    />
  );
};

export default RegRoute;
